<template lang="pug">
.of-second-background
    oc-section( sectionId='of', title='Ortografía Financiera', :tabsContent='tabsContent',nextRef='#oe', inverted=true )
</template>

<script>
import OcSection from '@/components/shared/Section.vue'
import SECTION from  '@/constants/section-types'

export default {
    components: { OcSection },
    data() {
        return {
            SECTION,
            tabsContent: [
                { 
                    id: 'whatis', 
                    label: '¿Qué es?', 
                    active: true, 
                    inverted: true,
                    content: { 
                        type: SECTION.DEFINITION,
                        img: `${HOMEURL}img/of/logo.png`,
                        pUrl: '',
                        html: 'Es un curso – Taller que el objetivo principal es llevar a la persona a descubrir la información específica y personal que la mantiene bloqueada de cualquier forma con el Dinero. Es conocer los cómos y para que de la organización del dinero tanto personal, familiar y empresarial.<br><br>Basada en la estructura y funcionamiento cerebral con Ingeniería del pensamiento, P.N.L., inteligencias de Garner y Química cerebral. <br><br>Conoce tus Creencias, habilidades, fortalezas y debilidades, capitalízalas y transforma tu vida económica desde tu realidad personal, sin la influencia de irrealidades.<br><br>¡Date cuenta que si sigues haciendo lo que hasta ahora has hecho no llegaras mas lejos de donde estas!'
                    }
                },
                { 
                    id: 'photos', 
                    label: 'Fotos', 
                    active: false,
                    content: {
                        type: SECTION.POTHOS,
                        timeInterval: 20000,
                        slides: [
                            `${HOMEURL}img/of/slides/1.jpg`,
                            `${HOMEURL}img/of/slides/2.jpg`,
                            `${HOMEURL}img/of/slides/3.jpg`,
                            `${HOMEURL}img/of/slides/4.jpg`,
                            `${HOMEURL}img/of/slides/5.jpg`,
                            `${HOMEURL}img/of/slides/6.jpg`
                        ]
                    } 
                }
            ]
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/landing/Section2.vue